import { render, staticRenderFns } from "./property-management.vue?vue&type=template&id=2b39fcb4&scoped=true&"
import script from "./property-management.vue?vue&type=script&lang=js&"
export * from "./property-management.vue?vue&type=script&lang=js&"
import style0 from "./property-management.vue?vue&type=style&index=0&id=2b39fcb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b39fcb4",
  null
  
)

export default component.exports